'use strict';

var SystemStatusPanelController = function SystemStatusPanelController($scope, SystemConstants) {
  $scope.mode = null;
  $scope.$on('system-status:modeChanged', function (event, mode) {
    $scope.mode = mode;
  });
  $scope.isFlightSentScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.FLIGHT_SENT;
  };
  $scope.isServiceSentScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.SERVICE_SENT;
  };
  $scope.isReoptimizationScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.REOPTIMIZATION;
  };
  $scope.isReinitializationScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.REINITIALIZATION;
  };
  $scope.isOverbookingScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.OVERBOOKING;
  };
  $scope.isFlightReoptScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.FLIGHT_REOPT;
  };
  $scope.isMarketReoptScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.MARKET_REOPT;
  };
  $scope.isHistoryScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.HISTORY;
  };
  $scope.isFaresOptimizationScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.FO_FARES_REOPT;
  };
  $scope.isInterfaceStatusScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.INTERFACE_STATUS;
  };
};
SystemStatusPanelController.$inject = ['$scope', 'SystemConstants'];
module.exports = SystemStatusPanelController;